let elements = {
  mainImage: {
    imagePath: 'games/page002_game0/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  // withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  noClose: true,
  images: [
    {
      pos: {
        y: 203,
        x: 1514,
      },
      audio: {
        src: 'games/page002_game0/audio/klik.mp3',
      },
      // src: 'games/page002_game0/img/dron.png',
      src: 'games/page002_game0/img/bb.png',
      // close: true,
      correct: true,
      width: 69,
      height: 50,
      images: [
        {
          pos: {
            y: 154,
            x: 654,
          },
          src: 'games/page002_game0/img/statusCorrect.png',
          width: 50,
          height: 50,
        },
      ],
    },
    {
      pos: {
        y: 554,
        x: 1324,
      },
      audio: {
        src: 'games/page002_game0/audio/klik.mp3',
      },
      // src: 'games/page002_game0/img/komp.png',
      src: 'games/page002_game0/img/bb.png',
      // close: true,
      correct: true,
      width: 70,
      height: 130,
      images: [
        {
          pos: {
            y: 379,
            x: 784,
          },
          src: 'games/page002_game0/img/statusCorrect.png',
          width: 50,
          height: 50,
        },
      ],
    },
    {
      pos: {
        y: 374,
        x: 1100,
      },
      audio: {
        src: 'games/page002_game0/audio/klik.mp3',
      },
      // src: 'games/page002_game0/img/laptop.png',
      src: 'games/page002_game0/img/bb.png',
      // close: true,
      correct: true,
      width: 80,
      height: 53,
      images: [
        {
          pos: {
            y: 657,
            x: 330,
          },
          src: 'games/page002_game0/img/statusCorrect.png',
          width: 50,
          height: 50,
        },
      ],
    },
    //
    {
      pos: {
        y: 593,
        x: 1514,
      },
      audio: {
        src: 'games/page002_game0/audio/klik.mp3',
      },
      src: 'games/page002_game0/img/bb.png',
      // src: 'games/page002_game0/img/smartwatch.png',
      // close: true,
      correct: true,
      width: 50,
      height: 50,
      images: [
        {
          pos: {
            y: 383,
            x: 355,
          },
          src: 'games/page002_game0/img/statusCorrect.png',
          width: 50,
          height: 50,
        },
      ],
    },
    {
      pos: {
        y: 573,
        x: 1170,
      },
      audio: {
        src: 'games/page002_game0/audio/klik.mp3',
      },
      src: 'games/page002_game0/img/bb.png',
      // src: 'games/page002_game0/img/tablet.png',
      // close: true,
      correct: true,
      width: 70,
      height: 100,
      images: [
        {
          pos: {
            y: 665,
            x: 739,
          },
          src: 'games/page002_game0/img/statusCorrect.png',
          width: 50,
          height: 50,
        },
      ],
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'audio/test/test.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'none',
  //     },
  //     pos: {
  //       y: 0,
  //       x: 0,
  //     },
  //   },
  // ],
};

export default elements;
